import React, { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { attribution, track } from "@/lib/analytics";

/** Compact reusable callback form ("Richiamatemi"). */
export const QuickLeadForm = ({ title = "Vuoi sapere se SENIORCAR è adatta alle tue esigenze?", compact = false }) => {
  const [form, setForm] = useState({ first_name: "", phone: "", province: "", privacy_consent: false });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e?.target ? e.target.value : e });

  const started = React.useRef(false);
  const onFocus = () => { if (!started.current) { started.current = true; track("lead_form_start", { form: "quick" }); } };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.first_name || !form.phone) return toast.error("Inserisci nome e telefono.");
    if (!form.privacy_consent) return toast.error("È necessario accettare la privacy policy.");
    setLoading(true);
    try {
      await api.post("/leads", {
        ...form, lead_type: "quick", requested_action: "callback", ...attribution(),
      });
      track("qualified_lead", { form: "quick" });
      track("lead_form_submit", { form: "quick" });
      setSent(true);
      toast.success("Grazie! Ti ricontatteremo al più presto.");
    } catch { toast.error("Errore nell'invio. Riprova."); }
    finally { setLoading(false); }
  };

  if (sent) return (
    <div className="rounded-2xl bg-emerald-50 border border-emerald-200 p-6 text-center" data-testid="quick-lead-success">
      <CheckCircle2 className="mx-auto text-emerald-700 mb-2" size={40} />
      <p className="font-semibold text-emerald-900 text-lg">Richiesta inviata!</p>
      <p className="text-emerald-800/80 mt-1">Un nostro consulente ti richiamerà a breve.</p>
    </div>
  );

  return (
    <form onSubmit={submit} className={`rounded-2xl bg-white border border-slate-200 shadow-sm ${compact ? "p-5" : "p-6"}`} data-testid="quick-lead-form">
      <p className="font-bold text-slate-900 text-lg mb-4 leading-snug" style={{ fontFamily: "Outfit" }}>{title}</p>
      <div className="space-y-3">
        <Input placeholder="Nome" value={form.first_name} onChange={set("first_name")} onFocus={onFocus} className="h-12 text-base" data-testid="quick-name" />
        <Input placeholder="Telefono" value={form.phone} onChange={set("phone")} onFocus={onFocus} className="h-12 text-base" data-testid="quick-phone" />
        <Input placeholder="Provincia (es. MI)" value={form.province} onChange={set("province")} className="h-12 text-base" data-testid="quick-province" />
        <label className="flex items-start gap-2 text-sm text-slate-600">
          <Checkbox checked={form.privacy_consent} onCheckedChange={(v) => setForm({ ...form, privacy_consent: !!v })} data-testid="quick-privacy" className="mt-0.5" />
          <span>Ho letto e accetto la <a href="/privacy" className="underline">Privacy Policy</a>.</span>
        </label>
        <Button type="submit" disabled={loading} className="w-full h-12 text-base font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-amber)" }} data-testid="quick-submit">
          {loading ? "Invio..." : "RICHIAMATEMI"}
        </Button>
      </div>
    </form>
  );
};
